export const BULK_SEARCH_TERMINAL_STATUSES = [
  "finished",
  "completed_with_errors",
  "failed",
  "cancelled",
];

const BULK_SEARCH_STATUS_LABELS = {
  finished: "Listo",
  completed_with_errors: "Listo con errores",
  failed: "Falló",
  cancelled: "Cancelada",
};

const BULK_SEARCH_STATUS_NOTICES = {
  completed_with_errors: "Algunos contactos no se pudieron guardar.",
  failed: "La búsqueda masiva no se pudo completar.",
  cancelled: "La búsqueda masiva fue cancelada.",
};

export function isBulkSearchFinished(status) {
  return BULK_SEARCH_TERMINAL_STATUSES.includes(status);
}

export function isBulkSearchSuccessful(status) {
  return status === "finished" || status === "completed_with_errors";
}

export function getBulkSearchStatusLabel(status) {
  return BULK_SEARCH_STATUS_LABELS[status] ?? "En proceso";
}

export function getBulkSearchStatusNotice(status) {
  return BULK_SEARCH_STATUS_NOTICES[status] ?? null;
}
